import { useEffect, useState } from "react";
import { StickyNote } from "lucide-react";
import { useCanEdit } from "@/lib/app-context";

export function NoteInput({ value, onCommit, testId, className = "" }) {
  const canEdit = useCanEdit();
  const [v, setV] = useState(value || "");
  useEffect(() => { setV(value || ""); }, [value]);
  const commit = () => { if (v.trim() !== (value || "")) onCommit(v.trim()); };
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <StickyNote size={14} className="text-slate-400 shrink-0" />
      <input
        value={v}
        readOnly={!canEdit}
        title={v}
        maxLength={120}
        placeholder={canEdit ? "Add note…" : ""}
        onChange={(e) => setV(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
        className={`w-full min-w-0 bg-transparent rounded-md px-2 py-1.5 text-sm border border-transparent ${canEdit ? "hover:border-slate-200 focus:border-teal-500 focus:bg-teal-50/60" : "cursor-default"} focus:outline-none placeholder:text-slate-400`}
        data-testid={testId}
      />
    </div>
  );
}
